import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/course-list-action-types';

import type {List} from 'immutable';

export type CourseListStore = {
    courses: List<unknown>;
    matchingCoursesCount: number;
};

const initialState = () => {
    return {
        courses: Immutable.List(),
        matchingCoursesCount: 0,
    };
};

const actionsMap = {
    [actionTypes.GET_COURSES_SUCCESS]: (state, action) => {
        let courses = action.data.get('rows');
        const count = action.data.get('count');

        if (action.payload.page !== 0) {
            courses = state.courses.concat(courses);
        }

        return {
            courses,
            matchingCoursesCount: count,
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<CourseListStore>(initialState(), actionsMap);
